import { useNavigate } from "react-router-dom";
import { Alert, Button, Modal, ProgressBar } from "react-bootstrap";

export interface DeferredRequestInProgressViewProps {
  progress: number;
  cancelPolling: () => void;
}

const DeferredRequestInProgressView = ({
  progress,
  cancelPolling,
}: DeferredRequestInProgressViewProps) => {
  const navigate = useNavigate();

  const ok = () => {
    cancelPolling();
    navigate("/");
  };

  return (
    <>
      <Modal.Body>
        <Alert variant="info">Your data is being processed</Alert>
        <ProgressBar now={progress} />
        <div>
          You don't have to wait...
          <br />
          We will email you once the order is ready or go to 'My Orders' to download.
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={ok}>
          Ok
        </Button>
      </Modal.Footer>
    </>
  );
};

export default DeferredRequestInProgressView;
